(function(){
  'use strict';
  if (window.AdhekNavigationLoaded) return;
  window.AdhekNavigationLoaded = true;

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    var html = document.documentElement;
    var navBar = document.getElementById('navBar');
    var overlay = document.querySelector('.adhek-nav-overlay');
    var toggles = document.querySelectorAll('.menu-toggle');
    var mobileNav = document.getElementById('MobileNav');

    function isOpen(){ return html.classList.contains('show-nav'); }
    function syncToggleState(){
      var open = isOpen();
      toggles.forEach(function(btn){ btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    function closeMenu(){
      if (!isOpen()) return;
      html.classList.remove('show-nav');
      var siteHeader = document.querySelector('#shopify-section-header .site-header');
      if (siteHeader) siteHeader.classList.remove('site-header--hidden');
      syncToggleState();
    }

    if (overlay) overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeMenu(); });
    toggles.forEach(function(btn){ btn.addEventListener('click', function(){ setTimeout(syncToggleState, 0); }); });

    if (mobileNav) {
      mobileNav.addEventListener('click', function(e){
        var btn = e.target.closest('.mobile-nav--button');
        if (!btn || !mobileNav.contains(btn)) return;
        var parent = btn.closest('li');
        if (!parent) return;

        setTimeout(function(){
          var sameLevelItems = Array.prototype.filter.call(parent.parentNode.children, function(item){ return item !== parent; });
          sameLevelItems.forEach(function(item){
            item.classList.remove('nav-active');
            var itemBtn = item.querySelector(':scope > .mobile-nav--button');
            if (itemBtn) {
              itemBtn.classList.remove('nav-active');
              itemBtn.setAttribute('aria-expanded','false');
            }
            item.querySelectorAll('.nav-active').forEach(function(openItem){ openItem.classList.remove('nav-active'); });
            item.querySelectorAll('.mobile-nav--button[aria-expanded="true"]').forEach(function(openBtn){
              openBtn.classList.remove('nav-active');
              openBtn.setAttribute('aria-expanded','false');
            });
          });
        }, 0);
      });
    }

    document.addEventListener('click', function(e){
      var link = e.target.closest('#MobileNav a');
      if (link) closeMenu();
    });

    window.addEventListener('resize', function(){ if (window.innerWidth > 768) closeMenu(); });

    // Limpieza preventiva en desktop: si Supply deja un nav-hover activo,
    // se elimina cuando el cursor ya no está dentro del menú principal.
    var desktopNav = document.getElementById('AccessibleNav');
    document.addEventListener('mousemove', function(e){
      if (window.innerWidth <= 768 || !desktopNav) return;
      if (!desktopNav.contains(e.target)) {
        desktopNav.querySelectorAll('.nav-hover').forEach(function(item){
          item.classList.remove('nav-hover');
          var parentLink = item.querySelector(':scope > .site-nav--link');
          if (parentLink) parentLink.setAttribute('aria-expanded', 'false');
        });
      }
    }, { passive: true });



    syncToggleState();
  });
})();
